export default "__VITE_ASSET__CIAq9T3s__"